module.exports = __webpack_public_path__ + "media/application/images/2018/rd-2020-footer-twitter-e5576f7f71134013d878dd4d71246569.png";